import React from 'react';
import ResourcesHeader from '../components/resources/ResourcesHeader';
import ResourcesIntro from '../components/resources/ResourcesIntro';
import ResourceCard from '../components/resources/ResourceCard';
import ResourcesAdditional from '../components/resources/ResourcesAdditional';
import ResourcesCTA from '../components/resources/ResourcesCTA';
import cartillaConvivir from '../files/Anexo 2.pdf';
import protocoloDiseno from '../files/Anexo 5.pdf';

const Resources = () => {
  const resources = [
    {
      id: 1,
      title: 'Cartilla: Convivir sin Violencia',
      description: 'Una guía completa diseñada para promover la convivencia pacífica y el manejo constructivo de conflictos.',
      file: cartillaConvivir,
      fileName: 'Cartilla_Convivir_sin_Violencia.pdf',
      type: 'Cartilla Educativa',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
          <path d="M12 6v6"></path>
          <path d="M9 9h6"></path>
        </svg>
      ),
      color: '#0056b3'
    },
    {
      id: 2,
      title: 'Protocolo de Diseño',
      description: 'Documento técnico que establece las directrices y metodologías para el desarrollo de proyectos educativos.',
      file: protocoloDiseno,
      fileName: 'Protocolo_Diseño.pdf',
      type: 'Documento Técnico',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      ),
      color: '#003F81'
    }
  ];

  const handleDownload = (file, fileName) => {
    const link = document.createElement('a');
    link.href = file;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleView = (file) => {
    window.open(file, '_blank');
  };

  return (
    <section className="bg-fondo-claro" style={{ minHeight: 'calc(100vh - 120px)' }}>
      <ResourcesHeader />
      <div className="mx-auto px-5 py-[60px] max-w-[1200px]">
        <ResourcesIntro />
        <div className="grid gap-[40px] mb-[60px]" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))' }}>
          {resources.map((resource) => (
            <ResourceCard
              key={resource.id}
              resource={resource}
              onView={handleView}
              onDownload={handleDownload}
            />
          ))}
        </div>
        <ResourcesAdditional />
        <ResourcesCTA />
      </div>
    </section>
  );
};

export default Resources;
